"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dataCell_1 = __importDefault(require("../dataCell"));
const dataTable_1 = __importDefault(require("../dataTable"));
class JSONParser {
    constructor() {
        this.fileTypes = [
            'json',
            'application/json',
        ];
    }
    parse(content) {
        return __awaiter(this, void 0, void 0, function* () {
            let parsed = JSON.parse(content);
            let header = [];
            let data = [];
            let hasHeader = false;
            if (!Array.isArray(parsed)) {
                throw new Error("Content must be an array of objects");
            }
            for (let row of parsed) {
                if (typeof (row) != 'object') {
                    throw new Error("Each array element must be an object");
                }
                if (!hasHeader) {
                    hasHeader = true;
                    header = Object.keys(row);
                }
                data.push(header.map(col => {
                    if (!(col in row)) {
                        throw new Error("Column missing from object");
                    }
                    return new dataCell_1.default(row[col].toString());
                }));
            }
            return new dataTable_1.default(header, data);
        });
    }
    // Parse a single JSON object string
    parseLine(line) {
        return __awaiter(this, void 0, void 0, function* () {
            let parsed = JSON.parse(line);
            let out = [];
            if (typeof (parsed) != 'object') {
                throw new Error("Line must be an object");
            }
            for (let key of parsed) {
                out.push(parsed[key]);
            }
            return out;
        });
    }
}
exports.default = JSONParser;
